import fills from '../foundational-styles/fills';
var avatarColors = fills.options;
export default avatarColors;